module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/limit-flow-allowance/component/limit-flow-allowance/limit-flow-allowance.component.scss
// module id = ./src/app/limit-flow-allowance/component/limit-flow-allowance/limit-flow-allowance.component.scss
// module chunks = main